import { Provider } from "react-redux";
import { useRoutes } from "react-router-dom";
import { MatxTheme } from "./components";
import { AuthProvider } from "./contexts/JWTAuthContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import { Store } from "./redux/Store";
import routes from "./routes";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const App = () => {
  const content = useRoutes(routes);

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={Store}>
        <SettingsProvider>
          <MatxTheme>
            <AuthProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                {content}
              </LocalizationProvider>
            </AuthProvider>
          </MatxTheme>
        </SettingsProvider>
      </Provider>
    </QueryClientProvider>
  );
};

export default App;
